import { SET_SP_KEY_STATS_DATA } from "souqh-redux/reducers/actionConstants";
import { useAuthUser } from "../useLogin";
import { useDispatch, useSelector } from "react-redux";
import { useApiClient } from "../useApiClient";

export const useSPKeyStatisticsWidget = () => {
  const userInfo = useAuthUser();
  const dispatch = useDispatch();
  const { apiClient } = useApiClient();
  const { SPKeyStatisticsData } = useSelector((state) => state.keyStatistics);

  const getSPkeyStatisticsData = () => {
    dispatch({ type: "SET_LOADING", value: true });
    return apiClient
      .get(`keystatitics/service-provider?userId=${userInfo.userId}`)
      .then(function (response) {
        if (response.data.status === 200) {
          //   const data = mapKeysToReducer(response.data.result);
          dispatch({
            type: SET_SP_KEY_STATS_DATA,
            payload: response.data.result,
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .then(function () {
        dispatch({ type: "SET_LOADING", value: false });
      });
  };

  return {
    getSPkeyStatisticsData,
    SPKeyStatisticsData,
  };
};
